import { useEffect, useState } from "react";
import BreadCrumb from "../../../../components/breadcrumb";
import Header from "../../../../components/DashboardNavigation/header";
import Sidebar from "../../../../components/DashboardNavigation/sidebar";
import { JobData } from "../../../../components/tables/job-tables/job";
import { getAllApplications } from "../../../../API/Applications/applicationService";

const breadcrumbItems = [
  {
    title: "Candidatures emploi",
    link: "/admin-dashboard/candidatures-emploi",
  },
];
export default function Job() {
  const [applications, setApplications] = useState<any[]>([]);
  const fetchData = async () => {
    const response = await getAllApplications();
    setApplications(response?.applications);
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Header />
      <div className="flex h-screen overflow-hidden">
        <Sidebar />
        <div className="flex-1 p-4 pt-6 space-y-4 md:p-8">
          <BreadCrumb items={breadcrumbItems} />
          <JobData data={applications} />
        </div>
      </div>
    </>
  );
}
